
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal, createStyles, AspectRatio } from '@mantine/core';
import { FileSettings   } from 'tabler-icons-react';
import intl from "react-intl-universal";
import { set_modal_stapel_setup_open } from "../../slice/mainslice";

const useStyles = createStyles((theme) => ({
  sigcountdiv: {
    maxWidth: `25px`,
  },
  trackLabelsize: {
    fontSize: `12px`,
  },
}));




const AddUserToMeetingDrn = (props: any) => {
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const videoConferenceSettingsUrl = useSelector((state: any) => state.user.adduseriframelink) || []





  
      
   //  console.log("checked",checked)

        return (
            <>
  
                        <AspectRatio ratio={16 / 9} sx={{ maxWidth: 1920 }} mx="auto">
                              <iframe
                                  key={videoConferenceSettingsUrl}
                                  src={videoConferenceSettingsUrl}
                                  title={"Testraum"}
                                  allow="camera;microphone;display-capture"
                                  allowFullScreen
                                  frameBorder= "0"
                                />
                        </AspectRatio>

            </>
        );
    };

    


export default AddUserToMeetingDrn;